module.exports = __webpack_public_path__ + "media/bootstrap-icons/justify-0ad1d2dd.svg";